import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Loading from './components/Loading';
import Main from './components/Main';
import RSVPModal from './components/RSVPModal';
import LocationPage from './components/LocationPage';
import PhotoPage from './components/PhotoPage';
import AdminDashboard from './components/AdminDashboard';
import GiftPage from './components/GiftPage';
import fotoSposi from './images/loading.png';
import fotoSposiInterna from './images/foto_sposi_interna.png';
import locationImage from './images/location.png';
import './App.css';

function App() {
  const [isLoading, setIsLoading] = useState(() => {
    // Salta il caricamento se siamo in /admin
    return window.location.pathname !== '/admin';
  });
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Dati del matrimonio centralizzati
  const weddingData = {
   sposo : "Gianluca",
  sposa : "Pamela",
  fotoUrl : fotoSposiInterna,
  fotoLocationUrl: locationImage,
  data : "16 Maggio 2026",
  ora : "11:30",
  location : "Le 7 Fonti",
  indirizzo : "Via Prato della Corte 275, Roma",
  hotels: [
    {
      nome: "Hotel test",
      distanza: "5 min",
      descrizione: "Frase test.",
      link: "#"
    }
  ]
  };

  const handleConferma = () => {
    setIsModalOpen(true);
  };

  return (
    <div className="App">

      {isLoading ? (
        <Loading
          sposo={weddingData.sposo}
          sposa={weddingData.sposa}
          fotoUrl={fotoSposi}
          duration={2000}
          onComplete={() => setIsLoading(false)}
        />
      ) : (
        <Router>
          <ScrollToTop />
          <Header
            sposo={weddingData.sposo}
            sposa={weddingData.sposa}
            onConferma={handleConferma}
          />
          
          <RSVPModal 
            isOpen={isModalOpen} 
            onClose={() => setIsModalOpen(false)} 
          />

          <Routes>
            <Route
              path="/"
              element={
                <Main
                  sposo={weddingData.sposo}
                  sposa={weddingData.sposa}
                  fotoUrl={weddingData.fotoUrl}
                  fotoLocationUrl={weddingData.fotoLocationUrl}
                  data={weddingData.data}
                  ora={weddingData.ora}
                  location={weddingData.location}
                  indirizzo={weddingData.indirizzo}
                  hotels={weddingData.hotels}
                  onConferma={handleConferma}
                />
              }
            />
            <Route
              path="/location"
              element={<LocationPage />}
            />
            <Route
              path="/foto"
              element={<PhotoPage />}
            />
            <Route
              path="/regalo"
              element={<GiftPage />}
            />
            <Route
              path="/admin"
              element={<AdminDashboard />}
            />
          </Routes>
        </Router>
      )}
    </div>
  );
}

export default App;
